import { sGetFromEngagementTools } from '../../shared.min.js';

const cnfsd_insurance_group_calc = (function () {
	// API setup vars
	let apiUrl;
	let apiSubKey;

	// DOM Elements
	let regNumberField;
	let makeInput;
	let findGroupByRegButton;
	let calcResults;
	let insuranceText;
	let noDataError;
	let registrationNumberError;
	let autocompleteUl;
	let loadingSpinner;

	// Checks if car makes have been added to DOM
	let autocompleteUlIsEmpty = true;

	// Will hold vehicle information when vehicles are found
	let vehicles = [];
	let foundVehicle;

	// Object that will store all the car details retrieved from the API
	let carDetails = {
		registration: '',
		make: '',
		model: '',
		doors: '',
		fuel: '',
		year: '',
		engine: '',
		transmission: '',
		insuranceGroup: '',
		weight: 0,
	};

	// Copy the initial state of the carDetails object so that it is easy to reset it later
	const initialCarDetails = { ...carDetails };

	// Object to store references to DOM elements where car details are shown to the user
	const carUiDetails = {
		regUi: '',
		makeUi: '',
		modelUi: '',
		fuelUi: '',
		yearUi: '',
		engineUi: '',
		insGroupUi: '',
	};

	// Keeps track of the questions that have been answered in the manual lookup question set
	const answeredQuestions = [];

	// Init is called on DOMContentReady
	function init() {
		const calc = document.querySelector('.mod-insurance-group-calc');
		if (!calc) return;

		// Assigns a URL to use for all endpoints, based on the current window.location.hostname
		getApiDetails();

		// Assign DOM elements
		insuranceGroupCalculator.getCarUiDetails();
		regNumberField = document.getElementById('regNumber');
		makeInput = document.getElementById('make');
		calcResults = document.querySelector('.mod-insurance-group-calc  .calc-results');
		insuranceText = document.getElementById('insGroup-text');
		autocompleteUl = document.getElementById('autocompleteMake');
		loadingSpinner = document.getElementById('loading-spinner');
		noDataError = document.getElementById('error--no-data');
		registrationNumberError = document.getElementById('error--registration');

		// Add all click listeners
		insuranceGroupCalculator.addClickListeners();
		insuranceGroupCalculator.addChangeListeners();
		insuranceGroupCalculator.addKeyboardInputListeners();
	}

	// HELPER METHOD:: Retrieves the API URL based upon the hostname of where the app is running
	function getApiDetails() {
		const endpointSpan = document.getElementById('api-endpoint');
		apiUrl = endpointSpan ? endpointSpan.textContent : 'http://localhost:3000/vehicle-lookup';
		const subKeySpan = document.getElementById('sub-key');
		apiSubKey = subKeySpan ? subKeySpan.textContent : '';
	}

	// HELPER METHOD:: Calls an API endpoint. Takes in the API method to call and the parameters for that method.
	async function fetchVehicleDetails(apiMethod, apiParams) {
		// Checks for empty params on reg input
		const parts = apiParams.split('=');
		const params = parts[1];
		if (params == '' && apiMethod == 'registration') return [];

		const endpoint = `${apiUrl}/${apiMethod}?${new URLSearchParams(apiParams).toString()}`;
		insuranceGroupCalculator.toggleLoadingSpinner();

		try {
			const res = await sGetFromEngagementTools(apiSubKey, endpoint);
			if (!res.ok) throw new Error(res.status);

			const data = await res.json();

			// This should be cleaned up - tbh the whole manual search process needs a rethink
			let returnVal = '';
			if (data) {
				if (Array.isArray(data)) {
					returnVal = data;
				} else {
					const key = Object.keys(data)[0];
					returnVal = data[key];
				}
			}

			if (noDataError.style.display === 'block') noDataError.style.display = 'none';
			insuranceGroupCalculator.toggleLoadingSpinner();
			return returnVal;
		} catch (error) {
			insuranceGroupCalculator.toggleLoadingSpinner();
			if (apiMethod === 'registration') {
				insuranceGroupCalculator.addErrorMessage();
			}
			console.error('Fetch error for endpoint:', endpoint, 'Error:', error);
			throw error;
		}
	}

	// HELPER METHOD:: Takes in some data to store in local storage
	function storeInLocalStorage(data, dataName) {
		try {
			const dataString = JSON.stringify(data);
			localStorage.setItem(dataName, dataString);
		} catch (e) {
			console.error('Failed to save the data in localStorage:', e);
		}
	}

	// HELPER METHOD:: Retrieves data from local storage if it exists
	function getFromLocalStorage(dataName) {
		try {
			const dataString = localStorage.getItem(dataName);
			if (dataString) {
				return JSON.parse(dataString);
			} else {
				return null;
			}
		} catch (error) {
			console.error('Failed to retrieve data from localStorage:', error);
			return null;
		}
	}

	// HELPER METHOD:: Looks for all siblings that are of node type "fieldset".
	// Used to reset fieldsets when a user changes a value that they have already entered in the manual search.
	function getAllFollowingFieldsetSiblings(element) {
		let siblings = [];
		let currentElement = element;

		// "make" question has been changed
		if (!element.hasAttribute('id')) {
			siblings = [...document.querySelectorAll('.mod-subsection fieldset')];
			return siblings;
		}

		while (currentElement.nextElementSibling) {
			currentElement = currentElement.nextElementSibling;

			// Check if the sibling is a fieldset
			if (currentElement.nodeName === 'FIELDSET' && !currentElement.classList.contains('display-none')) {
				siblings.push(currentElement);
			}
		}

		return siblings;
	}

	function resetFieldsets(fieldsetsToReset) {
		fieldsetsToReset.forEach(fieldset => {
			const fieldsetSelect = fieldset.querySelector('select');
			if (fieldsetSelect) {
				// Select
				const enabledOptions = fieldsetSelect.querySelectorAll('option:enabled');

				enabledOptions.forEach(function (option) {
					option.remove();
				});

				fieldsetSelect.selectedIndex = 0;
			} else {
				// Radio
				const allRadios = fieldset.querySelectorAll('input-shell');
				allRadios.forEach(radio => radio.remove());
			}
			fieldset.classList.add('display-none');
		});
		const trimQuestion = document.getElementById('trim-question');
		if (trimQuestion) {
			if (!trimQuestion.classList.contains('display-none')) {
				const trimSelect = trimQuestion.querySelector('select');
				if (trimSelect) {
					const enabledOptions = trimSelect.querySelectorAll('option:enabled');

					enabledOptions.forEach(function (option) {
						option.remove();
					});

					trimSelect.selectedIndex = 0;
				}
				trimQuestion.classList.add('display-none');
			}
		}
	}

	function capitaliseFirstLetter(string) {
		if (!string || typeof string !== 'string') return '';
		return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
	}

	// MAIN WIDGET FUNCTIONALITY
	const insuranceGroupCalculator = {
		// ADDING CLICK LISTENERS
		addClickListeners: function () {
			this.addToggleFormListeners();
			this.addFindGroupButtonListeners();
			this.addAutocompleteMakeListener();
		},

		// START CLICK LISTENER FUNCTIONS
		addToggleFormListeners: function () {
			const toggleFormButtons = document.querySelectorAll('.makeandmodel, .back-to-reg');
			toggleFormButtons.forEach(button => {
				button.addEventListener('click', insuranceGroupCalculator.handleToggleFormButtonClick);
				if (button.classList.contains('makeandmodel')) {
					button.addEventListener('click', insuranceGroupCalculator.getVehicleMakes);
				}
			});
		},

		addFindGroupButtonListeners: function () {
			findGroupByRegButton = document.querySelector('#registration-lookup-button');
			if (findGroupByRegButton) {
				findGroupByRegButton.addEventListener('click', event => {
					insuranceGroupCalculator.handleFindGroupButtonClick(event);
				});
			}
		},

		addAutocompleteMakeListener: function () {
			const autoCompleteMake = document.getElementById('autocompleteMake');

			const handlerFunction = event => {
				if (event.target.classList.contains('autocomplete__option')) {
					const make = event.target.dataset.make;
					carDetails.make = make;
					insuranceGroupCalculator.handleMakeSelected(event.target.dataset.make);
				}
			};

			// Click
			autoCompleteMake.addEventListener('click', function (event) {
				handlerFunction(event);
			});

			// On enter or space
			autoCompleteMake.addEventListener('keydown', function (event) {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					handlerFunction(event);
				}
			});
		},
		// END CLICK LISTENER FUNCTIONS

		// ADD CHANGE LISTENER TO FORM SELECTS
		addChangeListeners: function () {
			const formSelects = document.querySelectorAll('#manual-lookup-form select');
			formSelects.forEach(selectElement => {
				selectElement.addEventListener('change', insuranceGroupCalculator.handleSelectChange);
			});

			const form = document.getElementById('manual-lookup-form');
			if (form) {
				form.addEventListener('change', insuranceGroupCalculator.handleRadioChange);
			}

			regNumberField.addEventListener('input', insuranceGroupCalculator.removeErrorClass);
		},

		addKeyboardInputListeners: function () {
			regNumberField.addEventListener('keydown', function (event) {
				if (event.key === 'Enter') {
					event.preventDefault();
					if (regNumberField.value.length >= 1) {
						findGroupByRegButton.click();
					}
				}
			});

			makeInput.addEventListener('keydown', function (event) {
				if (event.key === 'Enter') event.preventDefault();
			});

			regNumberField.addEventListener('input', e => {
				const alphanumericRegexWithSpaces = /[^A-Z0-9\s]/g;
				e.target.value = e.target.value.toUpperCase().replace(alphanumericRegexWithSpaces, '').slice(0, 8);
			});
		},

		// Gets a list of all vehicle makes, this is called on click of the "Search by make and model" button
		getVehicleMakes: async function () {
			const makesDataLocal = getFromLocalStorage('makesData');
			let res;
			if (!makesDataLocal) {
				res = await fetchVehicleDetails('makes', 'vehicleType=0');
				storeInLocalStorage(res, 'makesData');
			} else {
				res = makesDataLocal;
			}

			insuranceGroupCalculator.populateAutoFillOptions(res);
		},

		// This is called within "getVehicleMakes()", it populates the select with options for each make of car retrieved from the /makes endpoint
		populateAutoFillOptions: function (makes) {
			if (!autocompleteUlIsEmpty) return;

			if (!autocompleteUl) {
				console.warn('Autocomplete list not found.');
				return;
			}

			const fragment = document.createDocumentFragment();

			makes.forEach((make, index) => {
				const li = document.createElement('li');
				li.className = 'autocomplete__option display-none';
				li.setAttribute('aria-selected', 'false');
				li.setAttribute('id', `autoCompleteOption-${index}`);
				li.setAttribute('role', 'option');
				li.tabIndex = -1;
				li.dataset.make = make;
				li.textContent = make;

				fragment.appendChild(li);
			});

			while (autocompleteUl.firstChild) {
				autocompleteUl.removeChild(autocompleteUl.firstChild);
			}

			autocompleteUl.appendChild(fragment);

			insuranceGroupCalculator.addFilterToInput();

			autocompleteUlIsEmpty = false;
		},

		// Filters the list of makes based on the text added by the user
		addFilterToInput: function () {
			if (!makeInput || !autocompleteUl) {
				console.warn('Autocomplete input or list not found.');
				return;
			}

			makeInput.addEventListener('input', function () {
				const query = makeInput.value.toLowerCase();
				const options = document.querySelectorAll('.autocomplete__option');

				if (query.length < 2) {
					autocompleteUl.classList.add('display-none');
					return;
				} else {
					autocompleteUl.classList.remove('display-none');
				}

				options.forEach(option => {
					const text = option.textContent.toLowerCase();
					if (text.startsWith(query)) {
						const matchStart = text.indexOf(query);
						const matchEnd = matchStart + query.length;
						const highlightedString = `${option.textContent.slice(0, matchStart)}<strong>${option.textContent.slice(matchStart, matchEnd)}</strong>${option.textContent.slice(matchEnd)}`;
						option.innerHTML = highlightedString;
						option.classList.remove('display-none');
						option.tabIndex = '0';
					} else {
						option.innerHTML = option.textContent;
						option.classList.add('display-none');
						option.tabIndex = '-1';
					}
				});
			});
		},

		// Handles what to do when a select input is changed by the user, based on what select was changed
		handleSelectChange: async function (event) {
			const select = event.target;
			const question = select.options[select.selectedIndex].dataset.question;

			if (answeredQuestions.includes(question)) {
				const fieldsetParent = select.closest('fieldset');
				const fieldsetsToReset = getAllFollowingFieldsetSiblings(fieldsetParent);

				// Reset carDetails properties for everything AFTER changed question in answerQuestions[]
				insuranceGroupCalculator.updateCarDetails(question);

				// Reset html for every fieldset in fieldsetsToReset
				resetFieldsets(fieldsetsToReset);
			} else {
				answeredQuestions.push(question);
			}

			let selectedVal = select.value;

			let paramsBase = 'vehicleType=0&make='.concat(carDetails.make, '&model=').concat(carDetails.model); // Helper function to build query params

			const buildQueryParams = additionalParams => ''.concat(paramsBase, '&').concat(additionalParams);

			try {
				switch (question) {
					case 'model':
						carDetails.model = selectedVal;
						paramsBase = 'vehicleType=0&make='.concat(carDetails.make, '&model=').concat(carDetails.model); // reset this here as this is the only place that carDetails.model will not be defined first

						await insuranceGroupCalculator.handleOptionSelected(
							selectedVal,
							question,
							'years',
							buildQueryParams(''),
							'year'
						);
						break;

					case 'year':
						carDetails.year = selectedVal;
						await insuranceGroupCalculator.handleOptionSelected(
							selectedVal,
							question,
							'doors',
							buildQueryParams('manufactureYear='.concat(carDetails.year)),
							'doors'
						);
						break;

					case 'doors':
						carDetails.doors = selectedVal;
						await insuranceGroupCalculator.populateRadios('transmissions');
						break;

					case 'engine':
						carDetails.engine = selectedVal;
						const engineParams = 'year='
							.concat(carDetails.year, '&transmission=')
							.concat(carDetails.transmission, '&fuelType=')
							.concat(carDetails.fuel, '&engineSize=')
							.concat(carDetails.engine);
						await insuranceGroupCalculator.handleOptionSelected(
							selectedVal,
							question,
							'weights',
							buildQueryParams(engineParams),
							'',
							false
						);
						break;

					case 'trim':
						if (selectedVal === 'Standard Trim') {
							selectedVal = null;
						}

						const foundVehicle = vehicles.find(vehicle => vehicle.trimLevelName === selectedVal);
						if (foundVehicle)
							carDetails.insuranceGroup = foundVehicle.gr50Actual
								? foundVehicle.gr50Actual
								: foundVehicle.gr20Actual;

						if (!carDetails.insuranceGroup) {
							noDataError.style.display = 'block';
							return;
						} else if (/^\D*$/.test(carDetails.insuranceGroup)) {
							noDataError.style.display = 'block';
							return;
						} else {
							insuranceGroupCalculator.fillInResultsUi();
						}

						break;

					default:
						return;
				}

				insuranceGroupCalculator.handleAllCarDetailsFound();
			} catch (error) {
				console.error('Error handling select change:', error);
			}
		},

		handleAllCarDetailsFound: async function () {
			const propertiesToCheck = ['make', 'model', 'doors', 'fuel', 'year', 'engine', 'transmission'];
			const allDetailsPresent = propertiesToCheck.every(prop => carDetails[prop] !== '');

			if (!allDetailsPresent) {
				return;
			}

			vehicles = await fetchVehicleDetails(
				'search-vehicles-with-doors',
				`vehicleType=0&make=${encodeURIComponent(carDetails.make)}&model=${encodeURIComponent(carDetails.model)}&doors=${carDetails.doors}&fuelType=${encodeURIComponent(carDetails.fuel)}&year=${carDetails.year}&engineSize=${carDetails.engine}&grossWeight=${carDetails.weight}&transmission=${encodeURIComponent(carDetails.transmission)}`
			);

			if (!vehicles.length) {
				noDataError.style.display = 'block';
				return;
			}

			if (vehicles.length > 1) {
				insuranceGroupCalculator.populateTrims();
				return;
			}

			// At this point, there's exactly one vehicle in the list.
			foundVehicle = vehicles[0];
			const insuranceGroup = foundVehicle.gr50Actual ? foundVehicle.gr50Actual : foundVehicle.gr20Actual;

			if (!insuranceGroup || /^\D*$/.test(insuranceGroup)) {
				noDataError.style.display = 'block';
				return;
			}

			// Set insurance group and update UI.
			carDetails.insuranceGroup = insuranceGroup;
			insuranceGroupCalculator.fillInResultsUi();
		},

		populateTrims: function () {
			if (vehicles.length === 0) return;
			const trims = vehicles.map(vehicle => (vehicle.trimLevelName ? vehicle.trimLevelName : 'Standard Trim'));
			if (trims.length === 1) {
				foundVehicle = vehicles[0];
				if (foundVehicle)
					carDetails.insuranceGroup = foundVehicle.gr50Actual
						? foundVehicle.gr50Actual
						: foundVehicle.gr20Actual;
				if (!carDetails.insuranceGroup || /^\D*$/.test(carDetails.insuranceGroup)) {
					noDataError.style.display = 'block';
				} else {
					insuranceGroupCalculator.fillInResultsUi();
				}
			} else if (trims.length > 1) {
				insuranceGroupCalculator.toggleLoadingSpinner();
				insuranceGroupCalculator.populateOptions(trims, 'trim', 'trimOption', 'trim_controls');
				document.getElementById('trim-question').classList.remove('display-none');
				insuranceGroupCalculator.toggleLoadingSpinner();
			} else {
				console.error('NO TRIMS FOUND');
				noDataError.style.display = 'block';
			}
		},

		handleRadioChange: async function (event) {
			let res;
			const questionAnswered = event.target.dataset.question;

			if (answeredQuestions.includes(questionAnswered)) {
				const fieldsetParent = event.target.closest('fieldset');
				const fieldsetsToReset = getAllFollowingFieldsetSiblings(fieldsetParent);

				// Reset carDetails properties for everything AFTER changed question in answerQuestions[]
				insuranceGroupCalculator.updateCarDetails(questionAnswered);

				// Reset html for every fieldset in fieldsetsToReset
				resetFieldsets(fieldsetsToReset);
			} else {
				if (questionAnswered) answeredQuestions.push(questionAnswered);
			}

			switch (questionAnswered) {
				case 'transmissions':
					carDetails.transmission = event.target.value;
					res = await fetchVehicleDetails(
						'fuel',
						`vehicleType=0&make=${carDetails.make}&model=${carDetails.model}&year=${carDetails.year}&transmission=${carDetails.transmission}`
					);

					await insuranceGroupCalculator.populateRadios('fuel', res);

					break;
				case 'fuel':
					carDetails.fuel = event.target.value;
					res = await fetchVehicleDetails(
						'engine',
						`vehicleType=0&make=${carDetails.make}&model=${carDetails.model}&year=${carDetails.year}&transmission=${carDetails.transmission}&fuelType=${carDetails.fuel}`
					);

					if (res.length === 1) {
						carDetails.engine = res[0];
						if (!answeredQuestions.includes('engine')) answeredQuestions.push('engine');
					} else {
						insuranceGroupCalculator.populateOptions(res, 'engine', 'engineOption', 'engine_controls');
						document.getElementById('engine-question').classList.remove('display-none');
					}

					break;
				default:
					return;
			}
			insuranceGroupCalculator.handleAllCarDetailsFound();
		},

		toggleForms: function () {
			const formToShow = document.querySelector('form.display-none');
			const formToHide = document.querySelector('form:not(form.display-none)');
			if (formToShow) formToShow.classList.remove('display-none');
			if (formToHide) formToHide.classList.add('display-none');
		},

		handleFindGroupButtonClick: async function (event) {
			event.preventDefault();

			let res;

			insuranceGroupCalculator.toggleButtonIsLoading();

			carDetails.registration = regNumberField.value.replace(/\s+/g, '');

			if (carDetails.registration === '') {
				insuranceGroupCalculator.addErrorMessage();
				return;
			}

			const userRegLength = carDetails.registration.replaceAll(' ', '').length;
			if (userRegLength > 7 || userRegLength < 2) {
				insuranceGroupCalculator.addErrorMessage();
				return;
			}

			insuranceGroupCalculator.removeErrorClass();

			res = await fetchVehicleDetails('registration', `registrationNumber=${carDetails.registration}`);

			if (!res || Object.keys(res).length === 0) {
				insuranceGroupCalculator.addErrorMessage();
				return;
			}

			insuranceGroupCalculator.fillInCarDetailsFromReg(res);
			insuranceGroupCalculator.fillInResultsUi(true);

			insuranceGroupCalculator.toggleButtonIsLoading();
		},

		handleToggleFormButtonClick: function (e) {
			e.preventDefault();
			insuranceGroupCalculator.resetUi();
			const buttonClicked = e.target;
			insuranceGroupCalculator.toggleForms();
			if (
				buttonClicked.classList.contains('back-to-reg') ||
				buttonClicked.parentElement.classList.contains('back-to-reg')
			) {
				calcResults.classList.add('display-none');
			}
		},

		// Assigns all the DOM elements where car details where get added to the UI. Assigns them to an object.
		getCarUiDetails: function () {
			const fields = ['reg', 'make', 'model', 'fuel', 'year', 'engine', 'insGroup'];
			fields.forEach(field => {
				carUiDetails[`${field}Ui`] = document.getElementById(`car-${field}`);
			});
		},

		fillInCarDetailsFromReg: function (res) {
			if (res.manufacturerBrandName) carDetails.make = res.manufacturerBrandName;
			if (res.abiDescription) carDetails.model = res.abiDescription;
			if (res.primaryFuelTypeName) carDetails.fuel = res.primaryFuelTypeName;
			if (res.cubicCapacity) carDetails.engine = res.cubicCapacity;
			if (res.registrationYear) carDetails.year = res.registrationYear;
			carDetails.insuranceGroup = res.gr50Actual ? res.gr50Actual : res.gr20Actual;
		},

		getInsuranceText: function (groupNumber) {
			let textToReturn;
			if (groupNumber >= 1 && groupNumber <= 10) {
				textToReturn = document.querySelector('span[data-insurance-group-key="1-10"]').dataset
					.insuranceGroupValue;
			} else if (groupNumber >= 11 && groupNumber <= 20) {
				textToReturn = document.querySelector('span[data-insurance-group-key="11-20"]').dataset
					.insuranceGroupValue;
			} else if (groupNumber >= 21 && groupNumber <= 30) {
				textToReturn = document.querySelector('span[data-insurance-group-key="21-30"]').dataset
					.insuranceGroupValue;
			} else if (groupNumber >= 31 && groupNumber <= 40) {
				textToReturn = document.querySelector('span[data-insurance-group-key="31-40"]').dataset
					.insuranceGroupValue;
			} else if (groupNumber >= 41 && groupNumber <= 50) {
				textToReturn = document.querySelector('span[data-insurance-group-key="41-50"]').dataset
					.insuranceGroupValue;
			} else {
				textToReturn = document.querySelector('span[data-insurance-group-key="NA"]').dataset
					.insuranceGroupValue;
			}
			return textToReturn;
		},

		fillInResultsUi: function (isFromReg = false) {
			const fuelMapper = {
				1: 'Petrol',
				2: 'Diesel',
				3: 'Electric',
				4: 'Biofuel',
				5: 'Hydrogen',
				6: 'CNG',
				7: 'Unknown',
			};
			const registration = carDetails.registration.toUpperCase();
			const make = capitaliseFirstLetter(carDetails.make);
			const model = capitaliseFirstLetter(carDetails.model);
			const fuel = isFromReg ? carDetails.fuel : fuelMapper[carDetails.fuel];
			const year = carDetails.year;
			const engine = carDetails.engine;
			if (carDetails.registration && registration !== '') carUiDetails.regUi.textContent = `${registration},`;
			if (carDetails.make && make !== '') carUiDetails.makeUi.textContent = `${make},`;
			if (carDetails.model && model !== '') carUiDetails.modelUi.textContent = `${model},`;
			if (carDetails.fuel && fuel !== '' && fuel !== 'Unknown') carUiDetails.fuelUi.textContent = `${fuel},`;
			if (carDetails.year && year !== '') carUiDetails.yearUi.textContent = `${year},`;
			if (carDetails.engine && engine !== '') carUiDetails.engineUi.textContent = `${engine}`;
			if (carDetails.insuranceGroup && !/^\D*$/.test(carDetails.insuranceGroup)) {
				const insuranceGroupUi = carDetails.insuranceGroup.replace(/[^0-9]/g, '');
				carUiDetails.insGroupUi.textContent = `${insuranceGroupUi}/`;

				// Add text to page
				insuranceText.textContent = insuranceGroupCalculator.getInsuranceText(insuranceGroupUi);

				const forms = document.querySelectorAll('.mod-insurance-group-calc form');
				if (forms) {
					forms.forEach(form => {
						form.classList.add('display-none');
					});
				}
				const results = document.querySelector('.mod-insurance-group-calc .calc-results');
				if (results) results.classList.remove('display-none');
			} else {
				noDataError.style.display = 'block';
			}
		},

		handleMakeSelected: async function (make) {
			if (answeredQuestions.includes('make')) {
				const fieldset = document.querySelector('#manual-lookup-form > fieldset');
				const fieldsetsToReset = getAllFollowingFieldsetSiblings(fieldset);
				resetFieldsets(fieldsetsToReset);
				insuranceGroupCalculator.updateCarDetails('make');
			} else {
				answeredQuestions.push('make');
			}

			autocompleteUl.classList.add('display-none');
			document.getElementById('make').value = make;

			const res = await fetchVehicleDetails('models', `vehicleType=0&make=${carDetails.make}`);

			insuranceGroupCalculator.populateOptions(res, 'model', 'modelOption', 'model_controls');
			document.getElementById('model-question').classList.remove('display-none');
		},

		populateOptions: function (options, nextQuestion, optionId, nextQuestionId) {
			const fragment = document.createDocumentFragment();

			options.sort();

			options = options.filter((item, index, self) => self.indexOf(item) === index);

			options.forEach((option, index) => {
				const opt = document.createElement('option');
				opt.setAttribute('data-question', nextQuestion);
				opt.setAttribute('id', `${optionId}-${index}`);
				opt.setAttribute('value', option);
				opt.textContent = option;

				fragment.appendChild(opt);
			});

			document.getElementById(nextQuestionId).appendChild(fragment);
		},

		handleOptionSelected: async function (
			value,
			option,
			nextApiMethod,
			apiParams,
			nextQuestion,
			handleNextQuestion = true
		) {
			// Add question to answeredQuestions
			if (!answeredQuestions.includes(option)) {
				if (option) answeredQuestions.push(option);
			}

			carDetails[option] = value;
			const res = await fetchVehicleDetails(nextApiMethod, apiParams);

			if (handleNextQuestion) {
				// If response only has 1 option then we do not need to ask user the question, move onto the next question.
				if (res.length === 1) {
					switch (option) {
						case 'year':
							carDetails.doors = res[0];
							if (!answeredQuestions.includes('doors')) answeredQuestions.push('doors');
							await insuranceGroupCalculator.populateRadios('transmissions');
							break;
						case 'model':
							await insuranceGroupCalculator.handleOptionSelected(
								res[0],
								'year',
								'doors',
								`vehicleType=0&make=${carDetails.make}&model=${carDetails.model}&manufactureYear=${res[0]}`,
								'doors'
							);
							break;
						default:
							return;
					}
					return;
				} else {
					insuranceGroupCalculator.populateOptions(
						res,
						nextQuestion,
						`${option}Option`,
						`${nextQuestion}_controls`
					);
					document.getElementById(`${nextQuestion}-question`).classList.remove('display-none');
				}
			} else if (!handleNextQuestion) {
				if (res.length) {
					carDetails.weight = res[0];
				}
			}
		},

		populateRadios: async function (radiosToPopulate, data = null) {
			let res;
			let htmlString;

			switch (radiosToPopulate) {
				case 'transmissions':
					let transmissionFieldset;

					res = await fetchVehicleDetails(
						'transmissions',
						`vehicleType=0&make=${carDetails.make}&model=${carDetails.model}&year=${carDetails.year}`
					);

					if (res.length === 1) {
						carDetails.transmission = res[0];
						if (!answeredQuestions.includes('transmissions')) answeredQuestions.push('transmissions');
						res = await fetchVehicleDetails(
							'fuel',
							`vehicleType=0&make=${carDetails.make}&model=${carDetails.model}&year=${carDetails.year}&transmission=${carDetails.transmission}`
						);
						await insuranceGroupCalculator.populateRadios('fuel', res);
					} else {
						transmissionFieldset = document.getElementById('transmissions-question');
						const legendText = transmissionFieldset.querySelector('legend').textContent;
						htmlString = `<legend class="label--standard">${legendText ? legendText : 'Transmission type'}</legend>`;

						res.forEach(transmission => {
							/*
								API returns 1,2 or 3 for transmission types. 1 = manual, 2 = automatic, 3 = unknown
							*/
							if (transmission === 3) return;
							htmlString += `
								<div class="input-shell input-shell--option">
									<input aria-describedby="error-text--no-data" data-question="transmissions" id=${transmission === 1 ? 'transmissions_manual' : 'transmissions_automatic'} type="radio" name="transmissions_type" value=${transmission}>
									<label for=${transmission === 1 ? 'transmissions_manual' : 'transmissions_automatic'}>${transmission === 1 ? 'Manual' : 'Automatic'}</label>
								</div>
							`;
						});
						transmissionFieldset.innerHTML = htmlString;
						transmissionFieldset.classList.remove('display-none');
					}
					break;
				case 'fuel':
					if (data.length === 1) {
						carDetails.fuel = data[0];
						if (!answeredQuestions.includes('fuel')) answeredQuestions.push('fuel');
						res = await fetchVehicleDetails(
							'engine',
							`vehicleType=0&make=${carDetails.make}&model=${carDetails.model}&year=${carDetails.year}&transmission=${carDetails.transmission}&fuelType=${carDetails.fuel}`
						);

						if (res.length === 1) {
							carDetails.engine = res[0];
							if (!answeredQuestions.includes('engine')) answeredQuestions.push('engine');
						} else {
							insuranceGroupCalculator.populateOptions(res, 'engine', 'engineOption', 'engine_controls');
							document.getElementById('engine-question').classList.remove('display-none');
						}
					} else {
						const fuelFieldset = document.getElementById('fuel-question');
						const legendText = fuelFieldset.querySelector('legend').textContent;
						htmlString = `<legend class="label--standard">${legendText ? legendText : 'Fuel type'}</legend>`;
						/*
							Vehicle fuel type (petrol = 1, diesel = 2, electric = 3, biofuel = 4, hydrogen = 5, CNG = 6, unknown = 7)
						*/
						const fuelMapper = {
							1: 'Petrol',
							2: 'Diesel',
							3: 'Electric',
							4: 'Biofuel',
							5: 'Hydrogen',
							6: 'CNG',
							7: 'Unknown',
						};
						data.forEach(fuelType => {
							if (fuelType === 7) return;
							htmlString += `
								<div class="input-shell input-shell--option">
									<input data-question="fuel" id="fuel_${fuelMapper[fuelType].toLowerCase()}" type="radio" name="fuel_type" value=${fuelType}>
									<label for="fuel_${fuelMapper[fuelType].toLowerCase()}">${fuelMapper[fuelType]}</label>
								</div>
							`;
						});

						fuelFieldset.innerHTML = htmlString;
						fuelFieldset.classList.remove('display-none');
					}
					break;
				default:
					return;
			}
		},

		toggleButtonIsLoading: function () {
			if (!findGroupByRegButton) return;
			if (findGroupByRegButton.classList.contains('btn--loading')) {
				findGroupByRegButton.classList.remove('btn--loading');
			} else {
				findGroupByRegButton.classList.add('btn--loading');
			}
		},

		toggleLoadingSpinner: function (apiMethod) {
			// Spinner is in the button if using registration
			if (apiMethod === 'registration' || apiMethod === 'weights') return;

			if (loadingSpinner.classList.contains('display-none')) {
				loadingSpinner.classList.remove('display-none');
				loadingSpinner.setAttribute('aria-hidden', 'false');
			} else {
				loadingSpinner.classList.add('display-none');
				loadingSpinner.setAttribute('aria-hidden', 'true');
			}
		},

		addErrorMessage() {
			insuranceGroupCalculator.toggleButtonIsLoading();
			regNumberField.parentElement.classList.add('error');
			regNumberField.setAttribute('aria-invalid', 'true');
			registrationNumberError.style.display = 'block';
		},

		removeErrorClass: function () {
			const parent = regNumberField.parentElement;
			registrationNumberError.style.display = 'none';
			regNumberField.removeAttribute('aria-invalid');
			parent.classList.remove('error');
		},

		updateCarDetails: function (questionAnswered) {
			const questionIndex = answeredQuestions.indexOf(questionAnswered);

			const elementsAfterQuestion = answeredQuestions.slice(questionIndex + 1);

			if (elementsAfterQuestion.length > 0) {
				answeredQuestions.splice(questionIndex + 1);

				elementsAfterQuestion.forEach(question => {
					if (carDetails[question]) {
						if (question === 'weight') {
							carDetails[question] = 0;
						} else {
							carDetails[question] = '';
						}
					}
				});
			}
		},

		resetUi: function () {
			// Set carDetails back to it's initial empty state
			carDetails = { ...initialCarDetails };
			// Reset reg input
			regNumberField.value = '';
			// Reset all DOM elements that show car details
			const fields = ['reg', 'make', 'model', 'fuel', 'year', 'engine', 'insGroup'];
			fields.forEach(field => {
				carUiDetails[`${field}Ui`].textContent = '';
			});
			// Reset make field
			document.getElementById('make').value = '';
			// Reset all select elements
			const selects = ['model_controls', 'year_controls', 'doors_controls', 'engine_controls', 'trim_controls'];
			selects.forEach(select => {
				const selectElement = document.getElementById(select);
				const enabledOptions = selectElement.querySelectorAll('option:enabled');
				enabledOptions.forEach(function (option) {
					option.remove();
				});
				selectElement.selectedIndex = 0;
			});
			// Reset all radio elements
			const radios = ['transmissions-question', 'fuel-question'];
			radios.forEach(radio => {
				const question = document.getElementById(radio);
				const allRadios = question.querySelectorAll('input-shell');
				allRadios.forEach(radio => radio.remove());
			});
			// Add display none to all sub questions
			document
				.querySelectorAll('.mod-insurance-group-calc .mod-subsection fieldset')
				.forEach(fieldset => fieldset.classList.add('display-none'));
			// Remove reg error message
			insuranceGroupCalculator.removeErrorClass();
			// Remove any other errors
			noDataError.style.display = 'none';
		},
	};

	return {
		init: init,
		toggleButtonIsLoading: insuranceGroupCalculator.toggleButtonIsLoading,
		toggleLoadingSpinner: insuranceGroupCalculator.toggleLoadingSpinner,
	};
})();

document.addEventListener('DOMContentLoaded', function () {
	cnfsd_insurance_group_calc.init();
});
